(function() {
  'use strict';
  
  // Function to check and remove orphaned fee items
  async function removeOrphanedFeeItems() {
    try {
      // Fetch current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      if (!cart.items || cart.items.length === 0) return;
      
      // Find all main product variant IDs that are in the cart
      const mainProductVariantIds = new Set();
      cart.items.forEach(item => {
        const props = item.properties || {};
        // Items that have 'Engraving Type' or 'Ring size' are main products
        // Fee items have 'Fee for' or 'Quarter-size fee' property
        const isFeeItem = props['Fee for'] || (item.title && (item.title.includes('Text Engraving') || item.title.includes('Handwritten Engraving') || item.title.includes('Quarter-size fee')));
        
        if (!isFeeItem) {
          mainProductVariantIds.add(String(item.variant_id));
        }
      });
      
      // Find orphaned fee items
      const orphanedFeeKeys = [];
      cart.items.forEach(item => {
        const props = item.properties || {};
        const mainVariantId = props['Main variant id'];
        const feeFor = props['Fee for'];
        
        // Check if this is an engraving fee item
        if (feeFor && mainVariantId) {
          if (!mainProductVariantIds.has(String(mainVariantId))) {
            orphanedFeeKeys.push(item.key);
          }
        }
        
        // Check if this is a quarter-size fee item
        if (props['Main variant id'] && item.title && item.title.includes('Quarter-size fee')) {
          if (!mainProductVariantIds.has(String(mainVariantId))) {
            orphanedFeeKeys.push(item.key);
          }
        }
      });
      
      // Remove orphaned fee items
      if (orphanedFeeKeys.length > 0) {
        
        // Build updates object
        const updates = {};
        orphanedFeeKeys.forEach(key => {
          updates[key] = 0;
        });
        
        // Get sections to render
        const cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
        let sections = ['header-cart-status']; // Always include header cart status
        if (cartDrawerForm && typeof cartDrawerForm.getSectionsToRender === 'function') {
          const formSections = cartDrawerForm.getSectionsToRender().map(s => s.section).filter(Boolean);
          sections = [...new Set([...sections, ...formSections])]; // Merge and dedupe
        }
        
        // Remove orphaned items
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            updates: updates,
            sections: sections,
            sections_url: window.location.pathname
          })
        });
        
        const updatedCart = await updateResponse.json();
        
        // Re-render the cart drawer
        if (cartDrawerForm && updatedCart.sections) {
          cartDrawerForm.renderContents(updatedCart);
          
          // Also update the header cart status
          if (updatedCart.sections['header-cart-status']) {
            const headerCartStatus = document.querySelector('#headerCartStatus');
            if (headerCartStatus) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = updatedCart.sections['header-cart-status'];
              const newContent = tempDiv.querySelector('#headerCartStatus') || tempDiv.querySelector('.shopify-section');
              if (newContent) {
                headerCartStatus.innerHTML = newContent.innerHTML;
              }
            }
          }
        }
      }
    } catch (error) {
    }
  }
  
  // Intercept fetch to detect cart changes
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const result = originalFetch.apply(this, args);
    
    // Check if this is a cart change request
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (url.includes('/cart/change') || url.includes('/cart/update')) {
      result.then(() => {
        // Wait for cart to update, then check for orphaned fees
        setTimeout(removeOrphanedFeeItems, 1000);
      }).catch(() => {});
    }
    
    return result;
  };
  
})();
